import { VueController } from 'util/vue-controller'

// Connects to data-controller="booking-page"
export default class extends VueController {
  static vueComponent = 'booking-page'

  static values = {
    appointment: Object,
    avatarImageUrl: String,
    config: Object,
    translations: Object,
    view: String
  }

  get props () {
    return {
      appointment: this.appointmentValue,
      avatarImageUrl: this.avatarImageUrlValue,
      config: this.configValue,
      translations: this.translationsValue,
      view: this.viewValue ?? 'create'
    }
  }
}
